import { useState } from 'react';

export function useDineIn(defaultChoice) {
    const [value, setValue] = useState({});

    return {
        value,
        setValue,
    };
}
